import React from 'react';
import styles from './Primitives.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface MissingImageProps {
  /** Text or node to display next to the icon */
  message?: React.ReactNode;
  /** Additional class(es) applied to the wrapper; these are appended so you can override styling */
  className?: string;
  /** Additional class(es) applied to the icon element */
  iconClassName?: string;
  /** Optional icon override; accepts the FontAwesome `icon` prop (either an icon definition or array) */
  icon?: any;
  style?: React.CSSProperties;
}

/**
 * Reusable missing-image error component.
 * - Uses the `fa-image-slash` icon by default (expects you add the pro icon to the library in App.tsx or import it directly and pass it via `icon`).
 * - Accepts `className` and `iconClassName` so callers can provide styles that take precedence.
 */
export const MissingImage: React.FC<MissingImageProps> = ({
  message = 'Image not available',
  className = '',
  iconClassName = '',
  icon = ['far', 'image-slash'],
  style,
}) => {
  return (
    <div className={`${styles.missingImage} ${className}`} style={style} role="alert">
      <FontAwesomeIcon icon={icon} className={`${styles.errorIcon} ${iconClassName}`} aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
};

export interface FullWidthErrorMessageProps {
  /** Text or node to display */
  message: React.ReactNode;
  /** Additional class(es) applied to the wrapper; these are appended so you can override styling */
  className?: string;
  style?: React.CSSProperties;
}

export const FullWidthErrorMessage: React.FC<FullWidthErrorMessageProps> = ({ message, className = '', style }) => {
  return (
    <div className={`${styles.fullWidthErrorMessage} ${className}`} style={style} role="alert">
      {message}
    </div>
  );
};

export default MissingImage;
